import "./lib/polyfills";
import "./lib/error-logger";
import {createRoot} from "react-dom/client";

// Register service worker (only for main app, not steamy or open modes)
if (
  "serviceWorker" in navigator &&
  process.env.REACT_APP_MODE !== "steamy" &&
  process.env.REACT_APP_MODE !== "open"
) {
  window.addEventListener("load", () => {
    navigator.serviceWorker.register("/sw.js").catch((err) => {
      console.warn(err);
    });
  });
}

let appPromise;

if (process.env.REACT_APP_MODE === "steamy") {
  appPromise = import("./features/steamy/SteamyApp.jsx");
} else if (process.env.REACT_APP_MODE === "open") {
  appPromise = import("./features/public-project/PublicProjectApp.jsx");
} else {
  appPromise = import("./App.jsx");
}

const onLoaded = new Promise((res) => window.document.addEventListener("DOMContentLoaded", res));

Promise.all([appPromise, onLoaded]).then(([{default: App}]) => {
  const appEl = window.document.getElementById("app");

  const root = createRoot(appEl);
  root.render(<App tab="home" />);
  const loaderEl = window.document.getElementById("preload");
  if (loaderEl && loaderEl.parentNode) {
    loaderEl.parentNode.removeChild(loaderEl);
  }
});
